
import Vue, { PropType } from 'vue'
import { BulkSensorsTransactionRow } from '@/models'

import SensorBulkUploadListHeader from '@/views/company/sensors/components/SensorBulkUploadListHeader.vue'
import SensorBulkUploadListItem from '@/views/company/sensors/components/SensorBulkUploadListItem.vue'

export default Vue.extend({
  name: 'SensorBulkUploadList',

  props: {
    rows: Array as PropType<Array<BulkSensorsTransactionRow>>,
  },

  components: {
    SensorBulkUploadListHeader,
    SensorBulkUploadListItem,
  },
})
